/* global gpf */
const flowCalculator = {
	el: {
		flowWrapper: document.querySelector('.js-flow-calculator'),
		formVerifyDelay: document.querySelector('.js-form-verify-delay'),
		btnsNavigateToSection: document.querySelectorAll('.js-navigate-section'),
		btnsToggleSection: document.querySelectorAll('.js-toggle-section'),
		btnsValidateSection: document.querySelectorAll('.js-validate-section'),
		formPriority: document.querySelector('.js-form-priority'),
		btnValidatePriority: document.querySelector('.js-result-validate-priority'),
		flowContainers:document.querySelectorAll('.js-flow-step'),
		btnsResetRoute: document.querySelectorAll('.js-reset-route')
	},

	vars: {
		pagesGPF: ['login', 'falta-de-dados', 'utilizador-por-confirmar', 'reenviar-email-confirmacao', 'email-confirmacao-enviado', 'registar-se', 'informacao-em-falta', 'iniciar-registo']
	},

	fxToggleFieldset (btn) {
		const value = btn.value,
			sectionsWrapper = this.el.formVerifyDelay.querySelector(`.form__section[data-step=${btn.dataset.step}]`),
			sections = sectionsWrapper.querySelectorAll('.form__section--inner')

		for(const section of sections) {
			const inputs = section.querySelectorAll('.form__input-radio')

			if(section.dataset.section === value ) {
				section.classList.remove('d-none')
				inputs.forEach(input => {
					input.classList.remove('js-ignore')
					if(input.checked)
						input.checked = false
				})
			} else {
				section.classList.add('d-none')
				inputs.forEach(input => {
					input.classList.add('js-ignore')
					if(input.checked)
						input.checked = false
				})
			}
		}
	},

	fxNavigateToSection(btn) {
		const sectionId = btn.dataset.navigate,
			sections = this.el.formVerifyDelay.querySelectorAll('.form__section')

		for(const section of sections) {
			sectionId === section.dataset.step ? section.classList.remove('d-none') : section.classList.add('d-none')
		}
	},

	fxValidateSection(section) {
		const inputs = [...section.querySelectorAll('.form__input-radio:not(.js-ignore)')],
			btnNextSection = section.querySelector('.form__btn')

		const isChecked = el => {
			const radioChecked = [...document.querySelectorAll(`.form__input-radio[name="${el.name}"]`)].some(el => el.checked)
			return radioChecked
		}

		if(inputs.every(isChecked)) {
			btnNextSection.removeAttribute('disabled')
			return true
		} else {
			btnNextSection.disabled = true
			return false
		}
	},

	fxGetRoute () {
		if (window.location.hostname.includes('deco')) {
			const pathname = window.location.pathname
			if(pathname.split('/').at(-1) === 'vale-consulta') {
				return ''
			} else {
				return pathname.split('/').at(-1)
			}
		} else {
			return window.location.pathname
		}
	},

	fxNavigateToStep(containers, route = '0') {
		containers.forEach((container, i) => {
			const routes = ['registado', 'assinar-peticao', 'peticao', ...this.vars.pagesGPF],
				hasRoute = el => route.includes(el)
			//step 1
			if(route.length <= 1 || routes.some(hasRoute)) {
				container.dataset.flowStep === 'default' ? container.classList.remove('d-none') : container.classList.add('d-none')
			//other steps
			} else {
				route.includes(container.dataset.flowStep) ? container.classList.remove('d-none') : container.classList.add('d-none')
			}
		})
	},

	fxResetForms (container) {
		const forms = container.querySelectorAll('.form')

		forms.forEach(form => {
			form.reset()
			const radioBtns = form.querySelectorAll('.form__input-radio')

			if(radioBtns) {
				radioBtns.forEach(btn => {
					btn.checked = false
				})
			}
		})

		this.fxNavigateToStep(this.el.flowContainers, '0')
	},

	events() {
		if(this.el.formVerifyDelay) {
			for(const btn of this.el.btnsNavigateToSection) {
				btn.addEventListener('click', e => {
					this.fxNavigateToSection(e.currentTarget)
				})
			}

			for(const btn of this.el.btnsToggleSection) {
				btn.addEventListener('click', e => {
					this.fxToggleFieldset(e.currentTarget)
				})
			}

			//validate section on input change
			const inputs = this.el.formVerifyDelay.querySelectorAll('.form__input-radio')
			for(const input of inputs) {
				input.addEventListener('change', e => {
					const section = e.currentTarget.closest('.js-section')
					this.fxValidateSection(section)
				})
			}
			
			//show loader
			this.el.formVerifyDelay.addEventListener('submit', e => {
				formHelper.fxShowLoader(e.currentTarget)
			})
		}

		if(this.el.formPriority) {
			this.el.formPriority.addEventListener('submit', e => {
				formHelper.fxShowLoader(e.currentTarget)
			})

			//show next form
			if(this.el.btnValidatePriority) {
				this.el.btnValidatePriority.addEventListener('click', e => {
					formHelper.fxToggleDisplayStep(e.currentTarget)
				})
			}

			//validate priority form
			formValidation.fxValidations(this.el.formPriority)
		}

		//set flow navigation
		this.fxNavigateToStep(this.el.flowContainers, this.fxGetRoute())

		//reset flow on btn click
		for(const btn of this.el.btnsResetRoute) {
			btn.addEventListener('click', e => {
				this.fxResetForms(this.el.flowWrapper)
			})
		}

	},

	init () {
		if (!this.el.flowWrapper) return
		this.events()
	}
}

flowCalculator.init()